import React from 'react';

export default function HTML_Character_Sets() {
  return (
    <div className="HTML_Character_Sets">
      <h1>HTML Character Sets</h1>
      <p>This is the placeholder component for <strong>HTML Character Sets</strong>.</p>
      <p>Link: /html/reference/charsets</p>
    </div>
  );
}
